import { OPItem } from "@/interfaces/CardItem";
import { CDN } from "@/lib/cdn";

export function getDonData(format: string): OPItem {
  return {
    groupId: `${format}`,
    id: `DON-${format}`,
    imageUrl: `${CDN}/games/one-piece/images/en/DON/DON-${format}.webp`,
    attribute: "-",
    color: "-",
    name: `DON!! ${format}`,
    number: `DON-${format}`,
    rarity: "DON!!",
    type: "DON!!",
    counter: 0,
    description: "Your Turn +1000",
    subtype: "-",
    displayName: "DON!!",
    region: "EN",
    cost: 0,
  };
}
